import { RELATIONSHIP_REGISTRY } from "../../config/relationshipRegistry";
import { createDevConsole } from "../../utils/devLogger";

const console = createDevConsole();

const expandRelationshipTypes = (types = []) => {
  const expanded = new Set();
  types.forEach((type) => {
    if (!type) return;
    const value = String(type).trim();
    if (!value) return;
    expanded.add(value);
    expanded.add(value.toLowerCase());
    expanded.add(value.toUpperCase());
  });
  return Array.from(expanded);
};

const RELATIONSHIP_TYPE_MAPPING = Object.fromEntries(
  Object.entries(RELATIONSHIP_REGISTRY).map(([entityType, sections]) => {
    const sectionMappings = {};
    sections.forEach((section) => {
      sectionMappings[section.key] = {
        relationshipTypes: expandRelationshipTypes(
          section.relationshipTypes || []
        ),
        direction: section.direction,
        relatedEntityTypes: section.relatedEntityTypes || [],
      };
    });
    return [entityType, sectionMappings];
  })
);

const normalizeEntityTypeForMapping = (t) => {
  const s = String(t || "").toLowerCase();
  if (s === "organisation") return "organization";
  if (s === "org" || s === "org-unit" || s.includes("org unit"))
    return "organization";
  if (s.includes("applicationinterface") || s === "interface")
    return "interface";
  if (
    s.includes("application component") ||
    s.includes("applicationcomponent") ||
    s === "application"
  )
    return "application";
  if (
    s.includes("technologycomponent") ||
    s.includes("itcomponent") ||
    s.includes("it component")
  )
    return "technology-component";
  if (s.includes("dataobject") || s.includes("data object"))
    return "data-object";
  if (s.includes("businesscapability") || s.includes("business capability"))
    return "business-capability";
  if (s.includes("businesscontext") || s.includes("business context"))
    return "business-context";
  if (s === "solution-component" || s.includes("solution component"))
    return "solution-component";
  if (s === "platform" || s.includes("platform")) return "platform";
  return s;
};

export const getRelationshipMapping = (entityType, sectionKey) => {
  const normalizedEntityType = normalizeEntityTypeForMapping(entityType);
  const entityMappings = RELATIONSHIP_TYPE_MAPPING[normalizedEntityType];

  if (!entityMappings) {
    console.log(
      `🔍 [getRelationshipMapping] No mappings found for entity type:`,
      {
        originalType: entityType,
        normalizedType: normalizedEntityType,
        sectionKey: sectionKey,
        availableEntityTypes: Object.keys(RELATIONSHIP_TYPE_MAPPING),
      }
    );
    return null;
  }

  const mapping = entityMappings[sectionKey];
  if (!mapping) {
    console.log(`🔍 [getRelationshipMapping] No mapping found for section:`, {
      entityType: normalizedEntityType,
      sectionKey: sectionKey,
      availableSections: Object.keys(entityMappings),
    });
    return null;
  }

  return mapping;
};
